// extracted by mini-css-extract-plugin
export default {"links":"error-404_links__aQ2zw","header":"error-404_header__jiAlY","body":"error-404_body__DJrVx","error404":"error-404_error404__-V7qC"};